import ArticleLayout from "../components/ArticleLayout";

export default function AccessoriesGuide() {
  return <ArticleLayout articleId={11} />;
}